import { baseDeleteQuery } from '../../../../utility/sb-api/sb-api.service';
import { basePostQuery } from '../../../../utility/sb-api/sb-api.service';

export const removePaymentMethod = (id) =>
  baseDeleteQuery(
    `me/payment-methods/${id}`,
    null,
    'paymentMethodRemovedSuccess',
    'paymentMethodRemovedFail',
  );

export const createSetup = () => {
  return basePostQuery(`me/payment-methods`);
};
